import { AiOutlineUser } from "react-icons/ai";
import { numberFormat, shortenString } from "@lib/helpers/StringHelper";
import { Tag, Typography } from "antd";
import IntlMessages from "@lib/helpers/IntlMessages";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { green, red } from "@ant-design/colors";
import { TiInfoLarge } from "react-icons/ti";
import { FaUsers, FaWhatsapp } from "react-icons/fa";
import { IoIosApps } from "react-icons/io";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { AppListItemMetaProps } from "@lib/components/AppComponents/AppListNew";
import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";
import { Customer, CustomerOnlineAgent, WalletAddress } from "@lib/types";
import _ from "lodash";

type SidebarCustomerDetailListItemsType = {
  customer: Customer;
  isLoading: boolean;
  onlineAgentData?: CustomerOnlineAgent;
  isWhatsappPlatform?: boolean;
  aiCredit?: number;
  aiFreeCredit?: number;
};

export const SidebarCustomerDetailListItems = (
  props: SidebarCustomerDetailListItemsType,
) => {
  const {
    customer,
    isLoading,
    onlineAgentData,
    isWhatsappPlatform,
    aiCredit,
    aiFreeCredit,
  } = props;

  if (isLoading) return [];

  return [
    {
      title: <Typography.Text ellipsis>{customer?.name}</Typography.Text>,
      avatar: <AiOutlineUser />,
    },
    {
      avatar: <>ID</>,
      title: (
        <Typography.Text ellipsis>
          <TableIdButton
            text={`#${shortenString(customer.id, 20)}`}
            textToBeCopied={customer.id}
          />
        </Typography.Text>
      ),
    },
    ...(isWhatsappPlatform
      ? [
          {
            avatar: <FaWhatsapp />,
            title: (
              <StyledFlex style={{ justifyContent: "space-between" }}>
                <IntlMessages id="common.whatsappPlatform" />
              </StyledFlex>
            ),
          },
        ]
      : []),
    {
      avatar: <TiInfoLarge />,
      title: (
        <StyledFlex style={{ justifyContent: "space-between" }}>
          <IntlMessages id="common.accountStatus" />{" "}
          <Tag
            color={customer?.enabled ? green[7] : red[7]}
            style={{ margin: 0 }}
          >
            <IntlMessages
              id={customer?.enabled ? "common.enabled" : "common.disabled"}
            />
          </Tag>
        </StyledFlex>
      ),
    },
    {
      avatar: <IoIosApps />,
      title: (
        <StyledFlex style={{ justifyContent: "space-between" }}>
          <IntlMessages id="common.appStatus" />{" "}
          <Tag
            color={!customer?.isClosed ? green[7] : red[7]}
            style={{ margin: 0 }}
          >
            <IntlMessages
              id={!customer?.isClosed ? "common.enabled" : "common.disabled"}
            />
          </Tag>
        </StyledFlex>
      ),
    },
    ...(aiCredit || aiFreeCredit
      ? [
          {
            avatar: <IoIosApps />,
            title: (
              <StyledFlex style={{ justifyContent: "space-between" }}>
                <IntlMessages id="common.aiCredit" />
                <b>{numberFormat(aiCredit || 0, 0) || 0} $</b>
              </StyledFlex>
            ),
          },
          {
            avatar: <IoIosApps />,
            title: (
              <StyledFlex style={{ justifyContent: "space-between" }}>
                <IntlMessages id="common.aiFreeCredit" />
                <b>{numberFormat(aiFreeCredit || 0, 0) || 0} $</b>
              </StyledFlex>
            ),
          },
        ]
      : []),
    ...(onlineAgentData
      ? [
          {
            avatar: <FaUsers />,
            title: (
              <StyledFlex style={{ justifyContent: "space-between" }}>
                <IntlMessages id="common.onlineAgent" />
                <b>{onlineAgentData?.count || 0}</b>
              </StyledFlex>
            ),
          },
        ]
      : []),
  ] as AppListItemMetaProps[];
};

type SidebarWalletAddressSummaryListItemsType = {
  walletAddressData: WalletAddress[];
  isLoading: boolean;
};

export const SidebarWalletAddressSummaryListItems = ({
  walletAddressData,
  isLoading,
}: SidebarWalletAddressSummaryListItemsType) => {
  if (isLoading) return [];

  return (
    (walletAddressData?.map((item) => ({
      avatar: (
        <img
          src={walletAddressTypeImage(item.network)}
          style={{ maxHeight: "20px" }}
        />
      ),
      title: (
        <Typography.Text ellipsis>
          <TableIdButton
            text={`${shortenString(item.address, 18)}`}
            textToBeCopied={item.address}
          />
        </Typography.Text>
      ),
    })) as AppListItemMetaProps[]) || []
  );
};
